import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { TrainingLog } from './d4-training-log.service.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { PaginationResponse } from '../../shared/models/pagination-response.model';

@Injectable({ providedIn: 'root' })
export class D4TrainingLogService {
  route: string = environment.apiUrl + '/api/D4TrainingLogs';

  constructor(
    private _http: HttpClient
  ) {}

  getActiveTrainingLogs(page: number | null = 1, pageSize: number | null = 10): Observable<PaginationResponse<TrainingLog[]>> {
    let params: HttpParams = new HttpParams();
    params = params.appendAll({
      page: page ?? 1,
      pageSize: pageSize ?? 10
    });

    return this._http.get<PaginationResponse<TrainingLog[]>>(this.route, { params });
  }
}
